import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import i18n from "../utils/language/i18n";

const SUPPORTED = new Set(["en", "sv", "pt", "es"]);

/**
 * Applies ?lang= or ?language= from the URL on public pages (invoice, terms).
 */
export function usePublicPageLanguage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const raw = searchParams.get("lang") || searchParams.get("language");
    if (!raw) return;
    const code = String(raw).trim().toLowerCase().split("-")[0];
    if (!SUPPORTED.has(code)) return;
    i18n.changeLanguage(code);
    try {
      localStorage.setItem("language", code);
    } catch {
      /* ignore */
    }
  }, [searchParams]);
}
